module.exports = __webpack_public_path__ + "media/images/img_service_service_1-51d4828c2cbbfecf62bc879da43d6417.png";